export default __webpack_public_path__ + "static/RHR_logo-42dffe5c514c29119a78e1278c233ba4.png";